/** The `invite` area: the pages an item invitation and an account link open.
 *  Owned by the stage 2 slot people (docs/I18N.md §11). The invitation's
 *  landing first, then the account link's, each in its three states. */
export const invite = {
  // --- An item invitation (/invite/<token>) ---
  'invite.invalid.title': 'Invite unavailable',
  'invite.invalid.body':
    'This invite link is invalid or has expired. Ask whoever invited you to send a fresh one.',
  'invite.goHome': 'Go to Tesserano',
  /** The heading of a valid invitation and of a valid account link. */
  'invite.invitedBy': '{name} invited you',
  'invite.signin.body':
    'You have been invited to collaborate on Tesserano. Create a free account or sign in, then open this link again to accept.',
  'invite.createAccount': 'Create account',
  'invite.signIn': 'Sign in',
  'invite.claimable.body': 'Accept to join the work you were invited to and everything beneath it.',
  'invite.accept': 'Accept invite',

  // --- An account link (/join/<token>) ---
  'invite.join.invalid.title': 'Link unavailable',
  'invite.join.invalid.body':
    'This link is invalid, used up, or has expired. Ask whoever shared it for a fresh one.',
  'invite.join.signin.bodyGroup':
    'This link creates your Tesserano account and seats you in {group}.',
  'invite.join.signin.body': 'This link creates your Tesserano account.',
  'invite.join.haveAccount': 'I already have an account',
  'invite.join.claimable.bodyGroup': 'You are signed in. This link seats you in {group}.',
  'invite.join.claimable.body': 'You are signed in, and this link has nothing left to give you.',
  'invite.join.createAccount': 'Create account',
  'invite.join.joinGroup': 'Join {group}',
  'invite.join.continue': 'Continue',
} as const;
